// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1HFuj","header":"ClearentDisclaimer_header__1Yxil","inner":"ClearentDisclaimer_inner__vqRkD"};